import * as WindowOrientation from 'core-framework/window/orientation';

export const width = (windowArg = window) => windowArg.screen.width;
export const availableWidth = (windowArg = window) => windowArg.screen.availWidth || width(windowArg);
export const height = (windowArg = window) => windowArg.screen.height;
export const availableHeight = (windowArg = window) => windowArg.screen.availHeight || height(windowArg);

export const portraitAvailableHeight = (windowArg = window) => (WindowOrientation.isPortraitMode(windowArg) ? availableHeight(windowArg) : availableWidth(windowArg));
export const portraitAvailableWidth = (windowArg = window) => (WindowOrientation.isPortraitMode(windowArg) ? availableWidth(windowArg) : availableHeight(windowArg));

export const landscapeAvailableHeight = (windowArg = window) => (WindowOrientation.isLandscapeMode(windowArg) ? availableHeight(windowArg) : availableWidth(windowArg));
export const landscapeAvailableWidth = (windowArg = window) => (WindowOrientation.isLandscapeMode(windowArg) ? availableWidth(windowArg) : availableHeight(windowArg));

export const devicePixelRatio = (windowArg = window) => (windowArg && windowArg.devicePixelRatio ? windowArg.devicePixelRatio : 1);
export const colorDepth = (windowArg = window) => windowArg.screen.colorDepth;

export const innerWidth = (windowArg = window) => windowArg.innerWidth;
export const innerHeight = (windowArg = window) => windowArg.innerHeight;

export const on = (callback: () => void, windowArg = window) => windowArg.addEventListener('resize', callback);
export const off = (callback: () => void, windowArg = window) => windowArg.removeEventListener('resize', callback);
